import { API_URL_NEWS } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";

const getSingleNews = (uuid: string) =>
  apiInstance({
    url: API_URL_NEWS + uuid,
  });

export default getSingleNews;
